// check for other pages that we dont want the modal to pop on
const pagesToSkip = ['/console', '/checkout'];
const checkForSkippablePage = (path: string = '') => {
    if (typeof path === 'string') {
        if (new RegExp(pagesToSkip.join('|')).test(path.toLowerCase())) {
            return true;
        }
    }
    return false;
};

export default checkForSkippablePage;
